
define('ldsh!modules/form_editor/templates/preview_form', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<form role="form" class="form-vertical">\n\n</form>';

}
return __p
};});

